import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { NextArrowIcon } from "@Icons/MainIcons";
import { SubMenuItem } from "src/constants/modules";
import { MODULE_STYLE } from "../../constants";

const ModuleTile: FC<{ item: SubMenuItem }> = ({ item }) => {
  const { t } = useTranslation();
  return (
    <Link
      to={`${item.route}`}
      className="group relative flex h-full w-full shrink-0 cursor-pointer flex-col overflow-hidden rounded-xl text-start transition-all duration-200 hover:shadow-md"
    >
      <img
        src={MODULE_STYLE[item.type]?.image}
        alt={item.type}
        className="h-full w-full bg-background-subtle object-cover transition-transform duration-300 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background-overlay/80 via-background-overlay/20 to-transparent" />
      <div className="absolute bottom-10 flex w-full items-center justify-between px-3 md:px-7">
        <div>
          <div className="font-semibold text-font-inverted">{t(item.label)}</div>
          <div className="text-xs text-font-inverted">{t(`${item.label}Subtitle`)}</div>
        </div>
        <div className="text-font-active hidden rounded-full bg-background-default p-2 md:block">
          <NextArrowIcon />
        </div>
      </div>
    </Link>
  );
};

export default ModuleTile;
